import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col } from 'antd';

import { CustomFormItem, CustomRow } from './styles';

interface EvaluatorProps {
	evaluator: string;
}

export const Evaluator: React.FC<EvaluatorProps> = ({ evaluator }) => {
	return (
		<Col xs={24} sm={12} lg={24}>
			<CustomFormItem label={I18n.get('Evaluator')}>
				<CustomRow>{evaluator}</CustomRow>
			</CustomFormItem>
		</Col>
	);
};
